import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage, serviceMenuGroups, SiteLink } from './RedesignShell';

const primaryPages = [
  { href: '/', label: 'Главная', status: 'готово' },
  { href: '/services/vseuslugi/', label: 'Все услуги', status: 'готово' },
  { href: '/calculator/', label: 'Калькулятор разработки', status: 'готово' },
  { href: '/portfolio/', label: 'Портфолио', status: 'готово' },
  { href: '/blog/', label: 'Блог', status: 'готово' },
  { href: '/about/', label: 'О компании', status: 'готово' },
  { href: '/contacts/', label: 'Контакты', status: 'готово' },
];

const portfolioPages = [
  { href: '/portfolio/tech-store/', label: 'Кейс интернет-магазина техники', status: 'готово' },
  { href: '/portfolio/sokolniki-restaurant/', label: 'Кейс ресторана в Сокольниках', status: 'готово' },
  { href: '/portfolio/fitness-course-landing/', label: 'Кейс лендинга онлайн-курса', status: 'готово' },
];

const companyPages = [
  { href: '/vacancies/', label: 'Вакансии', status: 'готово' },
  { href: '/requisites/', label: 'Реквизиты', status: 'готово' },
  { href: '/privacy/', label: 'Политика конфиденциальности', status: 'заглушка' },
  { href: '/offer/', label: 'Оферта', status: 'заглушка' },
  { href: '/cookies/', label: 'Cookies', status: 'заглушка' },
  { href: '/sitemap/', label: 'Карта сайта', status: 'готово' },
];

const blogPages = [
  { href: '/blog/digital-trends-2024/', label: 'Топ-5 трендов digital-продвижения в 2026 году', status: 'готово' },
  { href: '/blog/mobile-roi/', label: 'ROI мобильного приложения для бизнеса', status: 'готово' },
  { href: '/blog/seo-top3/', label: 'SEO-кейс про ТОП-3', status: 'готово' },
];

const sitemapGroups = [
  { title: 'Основные разделы', eyebrow: 'core', links: primaryPages },
  {
    title: 'Услуги',
    eyebrow: 'services',
    links: serviceMenuGroups.flatMap((group) => [
      {
        href: group.href,
        label: group.title,
        status:
          group.href === '/services/yandex-maps/' ? 'готово' : group.links.length > 0 ? 'раздел' : 'заглушка',
      },
      ...group.links.flatMap((link) => [{
        ...link,
        status: (link.href.includes('/mobile/') && !['/services/mobile/', '/services/mobile/mvp/', '/services/mobile/ios/', '/services/mobile/android/', '/services/mobile/integrations/', '/services/mobile/aso/', '/services/mobile/publishing/'].includes(link.href)) || link.href.includes('/mini-apps/') ? 'заглушка' : 'готово',
      }, ...(link.children || []).map(child => ({ ...child, status: 'готово' }))]),
    ]),
  },
  { title: 'Кейсы', eyebrow: 'portfolio', links: portfolioPages },
  { title: 'Блог', eyebrow: 'blog', links: blogPages },
  { title: 'Компания и документы', eyebrow: 'company', links: companyPages },
];

function SitemapPage() {
  return (
    <RedesignPage>
      <PageMeta
        title="Карта сайта Fatality Studio — структура услуг, кейсов и разделов"
        description="Карта сайта Fatality Studio: основные разделы, услуги разработки сайтов, кейсы, блог, контакты и служебные страницы."
      />
      <RedesignHeader />

      <main>
        <section className="ink sitemap-hero">
          <div
            className="glow"
            style={{ right: '-320px', top: '-320px', width: '780px', height: '780px', opacity: 0.1 }}
          />
          <div className="container" style={{ position: 'relative' }}>
            <div className="eyebrow cyan">— структура сайта</div>
            <h1>Карта сайта</h1>
            <p>
              Список публичных разделов Fatality Studio. Готовые страницы открываются сразу, недостающие разделы ведут
              на брендированные заглушки и остаются в planning-документах до переноса исходных текстов.
            </p>
          </div>
        </section>

        <section className="canvas sec-pad">
          <div className="container sitemap-grid">
            {sitemapGroups.map((group) => (
              <article className="sitemap-card" key={group.title}>
                <div className="sitemap-card-head">
                  <span>{group.eyebrow}</span>
                  <h2>{group.title}</h2>
                </div>
                <ul className="sitemap-list">
                  {group.links.map((link) => (
                    <li key={`${group.title}-${link.href}`}>
                      <SiteLink href={link.href}>{link.label}</SiteLink>
                      <span>{link.status}</span>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </section>
      </main>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default SitemapPage;
